import React, { Component } from 'react';
import { Button, Card, Col, DatePicker, Form, Input, InputNumber, Row, Table } from 'antd';

import '../tabRow.less';
import util from '@util';
import moment from 'moment';
import { connect } from 'react-redux';
import { queryDeleteAttachment } from '@api/pub/attachment';
import UploadFile from '@comm/upload/UploadFile';
import { BackBtn } from '@comm/BackBtn';
import { Link } from 'react-router';

const FormItem = Form.Item;
const { TextArea } = Input;
class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      goodsList: [{ id: 0 }],
      goodsCount: 1,
      goodsSum: '',
      delFiles: [],
    };
  }

  componentDidMount() {
    const { data } = this.props;
    data.details &&
      data.details.length &&
      data.details.map(item => {
        item.id = item.uuid;
        item.unit && item.count ? (item.subtotal = item.unit * item.count) : (item.subtotal = 0);
        return item;
      });

    data.details &&
      data.details.length &&
      this.setState({
        goodsList: data.details,
        goodsCount: data.details.length,
        goodsSum: data.price,
      });
  }

  componentWillReceiveProps(nextProps) {
    const { data } = nextProps;
    data.details &&
      data.details.length &&
      this.setState({
        goodsList: data.details,
        goodsCount: data.details.length,
      });
  }

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handSubmit, data } = this.props;
    const { goodsList } = this.state;
    const params = {
      ...data,
      ...this.props.form.getFieldsValue(),
    };
    this.props.form.validateFields((err, values) => {
      if (!err) {
        goodsList.map(item => {
          item.name = values[`name${item.id}`];
          item.unit = values[`unit${item.id}`];
          item.model = values[`model${item.id}`];
          item.count = values[`count${item.id}`];

          delete params[`name${item.id}`];
          delete params[`unit${item.id}`];
          delete params[`model${item.id}`];
          delete params[`count${item.id}`];
          return item;
        });
        params.details = goodsList;
        params.expectedDate = params.expectedDate.valueOf();
        handSubmit(params);
        if (this.state.delFiles.length > 0) {
          this.state.delFiles.map(item => {
            queryDeleteAttachment({
              uuid: item.uuid,
            });
            return item;
          });
        }
      }
    });
  };

  /**
   *文件删除
   */
  fileRemove = file => {
    const { delFiles } = this.state;
    delFiles.push(file);
    this.setState({ delFiles });
  };

  start = e => {
    this.submit(e, null, 'start');
  };

  addGoods = () => {
    const { goodsList, goodsCount } = this.state;
    goodsList.push({ id: goodsCount });
    this.setState({
      goodsList,
      goodsCount: goodsCount + 1,
    });
  };

  deleteGoods = id => {
    const { goodsList } = this.state;
    this.setState({ goodsList: goodsList.filter(item => item.id !== id) }, () => {
      this.getGoodsSum();
    });
  };

  getGoodsSum = () => {
    const { goodsList } = this.state;
    let sum = 0;
    goodsList.map(item => {
      item.subtotal && (sum += item.subtotal);
      return item;
    });
    this.setState({
      goodsSum: sum,
    });
  };

  getGoodsSubtotal = id => {
    const { goodsList } = this.state;
    goodsList.map(item => {
      if (item.id === id) {
        item.unit && item.count ? (item.subtotal = item.unit * item.count) : (item.subtotal = 0);
      }

      return item;
    });
    this.setState(
      {
        goodsList,
      },
      this.getGoodsSum(),
    );
  };

  handleChangeGoodsUnit = (id, value) => {
    const { goodsList } = this.state;
    goodsList.map(item => {
      if (item.id === id) {
        item.unit = value;
      }
      return item;
    });
    this.setState({ goodsList }, this.getGoodsSubtotal(id));
    return value;
  };

  handleChangeGoodsNum = (id, value) => {
    const { goodsList } = this.state;
    goodsList.map(item => {
      if (item.id === id) {
        item.count = value;
      }
      return item;
    });
    this.setState({ goodsList }, this.getGoodsSubtotal(id));
    return value;
  };

  goodsColumns = () => {
    const { getFieldDecorator } = this.props.form;
    const { goodsList } = this.state;

    const arr = [
      {
        title: '*采购物品',
        dataIndex: 'name',
        key: 'name',
        width: '18%',
        render: (text, record) => {
          return (
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`name${record.id}`, {
                rules: [{ required: true, message: '请填写采购物品' }],
                initialValue: record.name || undefined,
              })(<Input placeholder="请填写采购物品" />)}
            </FormItem>
          );
        },
      },
      {
        title: '型号',
        dataIndex: 'model',
        key: 'model',
        width: '18%',
        render: (text, record) => {
          return (
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`model${record.id}`, {
                initialValue: record.model || undefined,
              })(<Input placeholder="请填写物品型号" />)}
            </FormItem>
          );
        },
      },
      {
        title: '*单价(元)',
        dataIndex: 'unit',
        key: 'unit',
        width: '18%',
        render: (text, record) => {
          return (
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`unit${record.id}`, {
                rules: [{ required: true, message: '请填写单价' }],
                initialValue: record.unit || undefined,
                getValueFromEvent: value => this.handleChangeGoodsUnit(record.id, value),
              })(<InputNumber placeholder="请填写物品单价" style={{ width: '100%' }} />)}
            </FormItem>
          );
        },
      },
      {
        title: '*数量',
        dataIndex: 'count',
        key: 'count',
        width: '18%',
        render: (text, record) => {
          return (
            <FormItem style={{ margin: 0, height: '60px' }}>
              {getFieldDecorator(`count${record.id}`, {
                rules: [{ required: true, message: '请填写数量' }],
                initialValue: record.count || undefined,
                getValueFromEvent: value => this.handleChangeGoodsNum(record.id, value),
              })(<InputNumber style={{ width: '100%' }} />)}
            </FormItem>
          );
        },
      },
      {
        title: '小计(元)',
        dataIndex: 'subtotal',
        key: 'subtotal',
        render: text => {
          return <div style={{ margin: 0, height: '40px' }}>{util.numberFormat(text)}</div>;
        },
      },
      {
        title: '操作',
        dataIndex: 'done',
        key: 'done',
        render: (text, record) => {
          return (
            <div style={{ margin: 0, height: '40px' }}>
              {goodsList && goodsList.length > 1 ? (
                <Link onClick={() => this.deleteGoods(record.id)}>删除</Link>
              ) : null}
            </div>
          );
        },
      },
    ];
    if (!goodsList || goodsList.length <= 1) {
      arr.pop();
    }
    return arr;
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { goodsList, goodsSum } = this.state;
    const { isSubmitting, data } = this.props;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
        md: { span: 18 },
      },
    };
    const formItemLayout2 = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 6 },
        md: { span: 6 },
      },
    };

    return (
      <Form style={{ marginTop: 8 }}>
        <div style={{ marginBottom: '16px' }} className="aaab">
          <BackBtn />
          <Button
            icon="upload"
            type="primary"
            style={{ marginRight: 10 }}
            onClick={this.start}
            loading={isSubmitting}
          >
            发起申请
          </Button>
          {data.uuid ? (
            <Button icon="delete" style={{ marginRight: 10 }} onClick={this.props.handleDelete}>
              删除
            </Button>
          ) : null}
        </div>
        <Card bordered={false} style={{ width: '100%' }}>
          <FormItem label="交付时间" {...formItemLayout2}>
            {getFieldDecorator('expectedDate', {
              rules: [{ required: true, message: '请选择期望交付时间' }],
              initialValue: data.expectedDate ? moment(data.expectedDate) : null,
            })(<DatePicker style={{ width: '100%' }} />)}
          </FormItem>
          <FormItem {...formItemLayout} label="采购物品">
            <div>
              <Table
                columns={this.goodsColumns()}
                dataSource={goodsList}
                pagination={false}
                rowKey="id"
                rowClassName="tabRow"
              />
              <Button onClick={this.addGoods} style={{ width: '100%', borderStyle: 'dashed' }}>
                +添加物品
              </Button>
              <Row type="flex">
                <Col>采购金额总计：</Col>
                <Col>{util.numberFormat(goodsSum)}元</Col>
              </Row>
            </div>
          </FormItem>
          <FormItem label="申请附件" {...formItemLayout2}>
            {getFieldDecorator('files', {
              initialValue: data.files,
            })(
              <UploadFile type="ghost" fileList={data.file} isPreview onRemove={this.fileRemove} />,
            )}
          </FormItem>
          <FormItem {...formItemLayout} label="申请说明">
            {getFieldDecorator('reason', {
              rules: [{ required: true, message: '请填写申请说明' }],
              initialValue: data.reason,
            })(<TextArea style={{ minHeight: 32 }} rows={4} />)}
          </FormItem>
          <FormItem label="申请人" {...formItemLayout}>
            {getFieldDecorator('crName', {
              initialValue: data.createUserName,
            })(<span>{this.props.accountInfo.userName}</span>)}
          </FormItem>
        </Card>
      </Form>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Form.create({ wrappedComponentRef: true })(BaseForm));



// WEBPACK FOOTER //
// ./src/components/administrative/purchase/FormBase.js